import { DomainEntityConfigModuleMap } from '@web-config-app/core';
import { nodesConfig } from '@web-config-app/masonry-nodes';
import { alertBannerConfig } from '@web-config-app/alert-banner';
import type { EntityId } from '../types/config';

/**
 * Constructs a map of domain entity config modules. These modules
 * are needed to provide configuration that can't be stored in JSON,
 * like React components, so we need to import them and inject
 * at runtime.
 */
export const domainEntityConfigModules: DomainEntityConfigModuleMap<EntityId> =
  new Map([
    ['nodes', nodesConfig],
    ['alert-banners', alertBannerConfig],
  ]);
